import { getDynamicBreadcrumbKey, getPathAncestry, } from '@sudoplatform-private/admin-web-utils';
import { Breadcrumb } from 'antd';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { findRouteMatch } from './findRouteMatch';
export const StyledBreadCrumb = styled(Breadcrumb) `
  padding: 12px 24px;
`;
export const BreadCrumbs = ({ routes, rootPaths, dynamicBreadcrumbs, }) => {
    const { pathname } = useLocation();
    const componentUrlPaths = getPathAncestry(pathname);
    const items = componentUrlPaths
        .map((path) => {
        const route = findRouteMatch(path, routes, rootPaths);
        return {
            path,
            linkText: getBreadcrumbText(route, path, dynamicBreadcrumbs) ||
                route?.displayName ||
                '',
        };
    })
        .filter((item) => !!item.linkText);
    return (React.createElement(StyledBreadCrumb, { separator: ">" }, items.slice(0).map((itemProps) => (React.createElement(Breadcrumb.Item, { key: itemProps.path },
        React.createElement(Link, { to: itemProps.path }, itemProps.linkText))))));
};
function getBreadcrumbText(route, path, dynamicBreadcrumbs) {
    const paramId = route?.path?.split('/').at(-1) ?? '';
    const paramValue = path.split('/').at(-1) ?? '';
    const key = getDynamicBreadcrumbKey({ paramId, paramValue });
    return dynamicBreadcrumbs.get(key);
}
